// $(function() {
//     var header = $("header > .container-fluid");
//     $(window).scroll(function() {
//         var scroll = $(window).scrollTop();
//
//         header.removeClass("width-stretch").addClass('width-shrink');
//         if (scroll >= 300) {
//         } else {
//             header.removeClass('width-shrink').addClass("width-stretch");
//         }
//     });
// });
//
// $('.section--call-to-action .col').matchHeight({
//                       property: 'height'
//                   });

                  $(function() {
                  	$('.section--call-to-action .col').matchHeight();
                  });


                  $(".paragraph-reveal").on("click", function(){
                    $(".words").toggleClass("open", 500, "easeOutSine");
                  });
